"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTripMap = function SvgTripMap(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.694 4.81v12.727m7.24.118v3.14",
    stroke: "#17181A",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.934 8.792a2.896 2.896 0 1 0 0-5.792 2.896 2.896 0 0 0 0 5.792Z",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.934 8.792v6.98m2.89-9.807 3.25-1.446v14.232l-6.265 2.632-7.002-3.264-6.11 2.212V6.089l5.953-1.8 4.37 1.714",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.934 3.724s1.523.12 1.926 1.261",
    stroke: "#17181A"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTripMap);
var _default = exports["default"] = Memo;